module.exports = __webpack_public_path__ + "static/img/03.48a33ba.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/companies/inno/03.jpg
// module id = 398
// module chunks = 1